export const CONFIGURATION_VIEW_MODEL_KEY = (guid: string): string =>
  `configurations:view:${guid}:model`;
